<template>
  <div v-if="members && members.length > 0" class="community-info-container">
    <div class="community-info">
      <div class="title-list">
        {{ $t('community.communityMembers.memberList') }}
      </div>
      <virtual-list class="members-container"
                    item-class="member-item"
                    :keeps="10"
                    :estimate-size="44"
                    :data-key="'id'"
                    :data-sources="members"
                    :data-component="itemComponent"
      />
    </div>
  </div>
</template>

<script>
import VirtualList from 'vue-virtual-scroll-list'
import CommunityMemberVirtualItem from './CommunityMemberVirtualItem'

export default {
  name: 'CommunityMembers',
  components: { VirtualList },
  props: {
    members: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      itemComponent: CommunityMemberVirtualItem
    }
  }
}
</script>

<style scoped lang="scss">
.community-info-container {
  width: 100%;
  margin: 1rem 0;

  .community-info {
    //width: 291px;
    height: fit-content;
    background-color: #FFFFFF;
    box-shadow: 2px 2px 8px 0 rgba(69, 69, 69, 0.2);
    padding-bottom: 0;

    @media (max-width: $medium) {
      width: auto;
      max-width: calc(25vw - 1rem);
    }
    @media (max-width: $header-change) {
      max-width: 100vw;
    }

    .title-list {
      padding: 12px 0;
      color: $black-color;
      font-weight: 600;
      font-size: 16px;
      height: 24px;
    }

    .members-container {
      // :keeps="10" must be more than visible items
      // :estimate-size="44" estimated size in px of each item
      // max visible item set to 7
      max-height: 44*5px;
      overflow-y: auto;
    }
  }
}

/* width */
::-webkit-scrollbar {
  width: 10px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #CCE5E9;
  border-radius: 100px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: rgb(255, 255, 255);
  border-radius: 100px;
  border: 2px solid #CCE5E9;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: rgb(243, 252, 255);
}
</style>
